import { CHAT_ENTRY_STATES, type ChatEntryState } from './resolveChatEntryState';

export function getChatEntryBlockedKey(state: ChatEntryState) {
    switch (state) {
        case CHAT_ENTRY_STATES.ERROR:
            return 'WHATSAPP_CHAT.ENTRY_LOAD_ERROR';
        case CHAT_ENTRY_STATES.NOT_ASSIGNED:
            return 'WHATSAPP_CHAT.ERROR.LOAN_REQUEST_NOT_ASSIGNED';
        default:
            return undefined;
    }
}
